import { AxiosError } from 'axios'
import { ApiClient } from '@/services/Http'

export const getSettings = async () => {
  try {
    const instance = await ApiClient()
    const { data } = await instance.get('settings')
    return data
  } catch (e) {
    const error = e as AxiosError
    const message = error.message || 'ERROR_GENERIC'
    throw new Error(message)
  }
}
